import React, { useContext } from "react";
import { useState } from "react";
import classNames from "classnames";
import { Button, Navbar } from "react-bulma-components";
import styled, { ThemeContext } from "styled-components";
import { Link } from "react-router-dom";

const StyledNavbar = styled(Navbar)`
  background: transparent;
`;

const StyledBurger = styled(Navbar.Burger)`
  backgroundcolor: transparent;
  color: black;
`;

function Menu({ menuConfig, ...props }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const theme = useContext(ThemeContext);

  var menuClassNames = classNames({
    "is-active": menuOpen,
  });
  var burgerClassNames = classNames({
    "navbar-burger": true,
    "is-active": menuOpen,
  });

  return (
    <StyledNavbar role="navigation" aria-label="main navigation">
      <Navbar.Brand>
        <Link to="/">
          <img
            className="navbar-item"
            src={process.env.PUBLIC_URL + menuConfig.imagePath}
            alt="Care"
            width="200"
          />
        </Link>
        <StyledBurger
          onClick={() => setMenuOpen(!menuOpen)}
          className={burgerClassNames}
          aria-label="menu"
          aria-expanded="false"
          data-target="navbar-menu"
        ></StyledBurger>
      </Navbar.Brand>

      <Navbar.Menu id="navbar-menu" className={menuClassNames}>
        <Navbar.Container align="left">
          <Navbar.Item>
            <Link to="/">Home</Link>
          </Navbar.Item>
          <Navbar.Item hoverable="true">
            <Navbar.Link>More</Navbar.Link>
            <Navbar.Dropdown>
              {/* <Navbar.Item>About</Navbar.Item> */}
              <Navbar.Item href="mailto:yungklein@gmail.com?subject=Care Enquiry">
                Contact
              </Navbar.Item>
              <Navbar.Divider />
              <Navbar.Item href="mailto:care@g.gabeos.cc?cc=yungklein@gmail.com&subject=Care Issue">
                Report an issue
              </Navbar.Item>
            </Navbar.Dropdown>
          </Navbar.Item>
        </Navbar.Container>

        <Navbar.Container align="right">
          <Navbar.Item renderAs="div">
            <Button
              href="mailto:yungklein@gmail.com?subject=Care Enquiry"
              color={theme.primary}
              renderAs="a"
            >
              <strong>Make an Enquiry</strong>
            </Button>
          </Navbar.Item>
        </Navbar.Container>
      </Navbar.Menu>
    </StyledNavbar>
  );
}

export default Menu;
